export var VehicleConfigurationKeyEnum;
(function (VehicleConfigurationKeyEnum) {
    VehicleConfigurationKeyEnum["ENABLE_TRAVEL_PACE"] = "ETP";
    VehicleConfigurationKeyEnum["ENABLE_COMPONENTS"] = "EC";
    VehicleConfigurationKeyEnum["ENABLE_ACTION_STATIONS"] = "EAS";
    VehicleConfigurationKeyEnum["ENABLE_LEVELS"] = "EL";
    VehicleConfigurationKeyEnum["ENABLE_COMPONENT_HIT_POINTS"] = "ECHP";
    VehicleConfigurationKeyEnum["ENABLE_COMPONENT_ARMOR_CLASS"] = "ECAC";
    VehicleConfigurationKeyEnum["ENABLE_COMPONENT_SPEEDS"] = "ECS";
    VehicleConfigurationKeyEnum["ENABLE_COMPONENT_MISHAP_THRESHOLD"] = "ECMT";
    VehicleConfigurationKeyEnum["ENABLE_COMPONENT_DAMAGE_THRESHOLD"] = "ECDT";
    VehicleConfigurationKeyEnum["ENABLE_COMPONENT_ARMOR_CLASS_MOTIONLESS"] = "ECACM";
    VehicleConfigurationKeyEnum["ENABLE_COMPONENT_CREW_REQUIREMENTS"] = "ECCR";
    VehicleConfigurationKeyEnum["ENABLE_COMPONENT_COVER"] = "ECC";
    VehicleConfigurationKeyEnum["ENABLE_COMPONENT_REMOVAL"] = "ECR";
    VehicleConfigurationKeyEnum["ENABLE_FEATURES"] = "EF";
    VehicleConfigurationKeyEnum["ENABLE_CONDITIONS_TRACKING"] = "ECT";
    VehicleConfigurationKeyEnum["ENABLE_FUEL_TRACKING"] = "EFT";
    VehicleConfigurationKeyEnum["PRIMARY_COMPONENT_MANAGE_TYPE"] = "PCMT";
    VehicleConfigurationKeyEnum["SIZE_TYPE"] = "ST";
    VehicleConfigurationKeyEnum["DISPLAY_TYPE"] = "DT";
})(VehicleConfigurationKeyEnum || (VehicleConfigurationKeyEnum = {}));
export var VehicleConfigurationDisplayTypeEnum;
(function (VehicleConfigurationDisplayTypeEnum) {
    VehicleConfigurationDisplayTypeEnum["SHIP"] = "ship";
    VehicleConfigurationDisplayTypeEnum["INFERNAL_WAR_MACHINE"] = "infernal-war-machine";
    VehicleConfigurationDisplayTypeEnum["SPELLJAMMER"] = "spelljammer";
    VehicleConfigurationDisplayTypeEnum["ELEMENTAL_AIRSHIP"] = "elemental-airship";
})(VehicleConfigurationDisplayTypeEnum || (VehicleConfigurationDisplayTypeEnum = {}));
export var VehicleConfigurationPrimaryComponentManageTypeEnum;
(function (VehicleConfigurationPrimaryComponentManageTypeEnum) {
    VehicleConfigurationPrimaryComponentManageTypeEnum["COMPONENT"] = "component";
    VehicleConfigurationPrimaryComponentManageTypeEnum["VEHICLE"] = "vehicle";
    VehicleConfigurationPrimaryComponentManageTypeEnum["ALL"] = "all";
})(VehicleConfigurationPrimaryComponentManageTypeEnum || (VehicleConfigurationPrimaryComponentManageTypeEnum = {}));
export var VehicleConfigurationSizeTypeEnum;
(function (VehicleConfigurationSizeTypeEnum) {
    VehicleConfigurationSizeTypeEnum["WEIGHT"] = "weight";
    VehicleConfigurationSizeTypeEnum["DIMENSION"] = "dimension";
})(VehicleConfigurationSizeTypeEnum || (VehicleConfigurationSizeTypeEnum = {}));
export var VehicleComponentGroupTypeEnum;
(function (VehicleComponentGroupTypeEnum) {
    VehicleComponentGroupTypeEnum["ACTION_STATION"] = "action-station";
    VehicleComponentGroupTypeEnum["COMPONENT"] = "component";
})(VehicleComponentGroupTypeEnum || (VehicleComponentGroupTypeEnum = {}));
